import update from 'immutability-helper';
import { ActionType, defaultAction } from '../types';
import { ACTION_TYPES } from '../types/notificationAnnouncementPreviewTypes';

export type NotificationAnnouncementPreviewCountState = {
  isTooltipOpen: boolean;
};

const initialState: NotificationAnnouncementPreviewCountState = {
  isTooltipOpen: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.SET_NOTIFICATION_TOOLTIP:
      return update(state, {
        $merge: {
          isTooltipOpen: payload,
        },
      });
    case ACTION_TYPES.TOGGLE_NOTIFICATION_TOOLTIP:
      return update(state, {
        $merge: {
          isTooltipOpen: !state.isTooltipOpen,
        },
      });
    default:
      return state;
  }
};
